import { render, staticRenderFns } from "./GlobalSearchNavigation.vue?vue&type=template&id=620b1878&scoped=true&"
import script from "./GlobalSearchNavigation.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchNavigation.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSearchNavigation.vue?vue&type=style&index=0&id=620b1878&scoped=true&lang=css&"
import style1 from "./GlobalSearchNavigation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b1878",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCardTitle,VIcon,VSlideXReverseTransition,VSlideXTransition})
